import { Editor } from "react-draft-wysiwyg";

const FormEditor = ({ editorState, onEditorStateChange, height="60vh", ...rest }) => {
  return (
    <Editor
      editorState={editorState}
      wrapperClassName="wrapper-class"
      editorClassName="editor-class input_description"
      editorStyle={{
        height: height,
        backgroundColor: "white",
        paddingLeft: "10px",
        paddingRight: "10px",
      }}
      toolbarClassName="toolbar-class"
      wrapperStyle={{
        border: "1px solid #ccc",
        paddingLeft: 0,
        paddingRight: 0,
      }}
      toolbar={{
        options: [
          "inline",
          "blockType",
          "fontSize",
          "list",
          "textAlign",
          "colorPicker",
          "link",
          "remove",
          "history",
        ],
      }}
      onEditorStateChange={onEditorStateChange}
      {...rest}
    />
  );
};

export default FormEditor;
